<template>
  <div class="relative flex-grow place-items-end pr-[40px] pt-[4px]">
    <!-- Trigger -->
    <div
      class="flex items-center justify-between gap-2 p-[8px] border border-black rounded-[10px] cursor-pointer select-none"
      @click="toggle"
    >
      <span>{{ selectedLabel }}</span>
      <ChevronDownIcon
        class="transition-transform"
        :class="{ 'rotate-180': open }"
      />
    </div>

    <!-- Dropdown -->
    <div
      v-if="open"
      class="absolute right-0 mt-[5px] w-1/2 bg-[#ffffff] border border-black rounded-[10px] shadow-lg z-50 p-[5px]"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="px-3 py-2 cursor-pointer hover:bg-gray-100"
        @click="select(option)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>
<script>
import ChevronDownIcon from './ChevronDownIcon.vue'

export default {
  name: 'ChatPlatformSelection',
  components: {
    ChevronDownIcon
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      required: true
      // [{ label: 'Option 1', value: 1 }]
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      open: false
    }
  },
  computed: {
    selectedLabel() {
      const selected = this.options.find(
        o => o.value === this.modelValue
      )
      return selected ? selected.label : 'Selecciona una empresa'
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    select(option) {
      this.$emit('update:modelValue', option.value)
      this.open = false
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.open = false
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>
